export class Assistenza {
  subject: string;
  message: string;
  attachment: File;
  threadId: string;
  isParent: string;
}

export class AssistenzaList {
  list: Assistenza[];
}

export class AssistenzaFE {
  subject: string;
  message: string;
  attachment: File;
  threadId: string;
  isParent: string;
  userId: string;
  picture: string;
  userName: string;
  insertDateTime: string;
  leftContent: string;
  rightContent: string;
}

export class PersonNameFE {
  name: string;
  surname: string;
  picture: string;
}

export class AssistenzaStatus {
  stato: string;
  stato_it: string;
}

export const ASSISTENZA_STATUS: AssistenzaStatus[] = [
  { stato: 'OPEN', stato_it: 'Aperto' },
  { stato: 'IN_MANAGE', stato_it: 'In gestione' },
  { stato: 'CLOSE', stato_it: 'Chiuso' }
]